import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const CompleteIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 32 24" fill="none">
    <path d="M1.96875 12.3636L10.7188 21L29.9688 2" stroke="currentColor" strokeWidth="4" />
  </svg>,
  'Complete'
);
